<ion-header>
  <ion-toolbar>
    <app-modal-back></app-modal-back>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p>
    Apple and Google have announced that mobile operating systems older than Android 7 are now end-of-life and will no
    longer receive software and security updates. As a result, from August 1st, the Mable app will only be accessible on
    mobile devices with Android OS 7+ to avoid potential performance issues and security risks. To continue using the
    Mable app, please upgrade your mobile operating system or use a computer to access your account via the Mable
    website.
  </p>

  <p>
    Please see End of life link for more information:
    <mable-button
      category="link"
      (onClick)="openEndOfLifeLink()"
      >End of life</mable-button
    >
  </p>
</ion-content>
